import React from 'react'
import SectionCTA from '../../components/Global/SectionCTA'
import AllBlog from './AllBlog'

function marketingIndex() {
  return (
    <>
      <SectionCTA />
      <AllBlog />
    </>
  )
}

export default marketingIndex
